import { Shimmer } from "../../../../components/common/shimmer";

/**
 * Loading skeleton for the product details page. Mirrors the layout of
 * `BuyerProductDetailsView` + `SimilarProductsSection` so the page does not
 * jump when real data resolves.
 */
export function ProductDetailsSkeleton() {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading product"
      className="flex flex-col gap-8"
    >
      <Shimmer className="h-4 w-64" />

      <div className="grid grid-cols-1 items-start gap-8 lg:grid-cols-3">
        <div className="flex flex-col gap-3">
          <Shimmer className="aspect-square w-full rounded-lg" />
          <div className="grid grid-cols-4 gap-2">
            {Array.from({ length: 4 }).map((_, i) => (
              <Shimmer key={i} className="aspect-square w-full rounded-md" />
            ))}
          </div>
        </div>

        <div className="flex min-w-0 flex-col gap-5">
          <Shimmer className="h-8 w-11/12" />
          <Shimmer className="h-8 w-3/4" />
          <div className="flex flex-wrap gap-2">
            <Shimmer className="h-6 w-24 rounded-full" />
            <Shimmer className="h-6 w-32 rounded-full" />
          </div>
          <Shimmer className="h-4 w-2/3" />

          {Array.from({ length: 3 }).map((_, group) => (
            <div key={group} className="flex flex-col gap-2">
              <Shimmer className="h-3 w-20" />
              <div className="flex flex-wrap gap-2">
                {Array.from({ length: 4 }).map((_, i) => (
                  <Shimmer key={i} className="h-9 w-16 rounded-md" />
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-4 rounded-lg border border-uiSecondary p-5">
          <Shimmer className="h-9 w-1/2" />
          <Shimmer className="h-4 w-1/3" />
          <div className="flex flex-col gap-2 pt-2">
            {Array.from({ length: 3 }).map((_, i) => (
              <Shimmer key={i} className="h-10 w-full rounded-md" />
            ))}
          </div>
          <Shimmer className="h-10 w-32 rounded-md" />
          <Shimmer className="h-11 w-full rounded-md" />
          <Shimmer className="h-11 w-full rounded-md" />
        </div>
      </div>

      <div className="flex flex-col gap-3">
        <Shimmer className="h-6 w-40" />
        <Shimmer className="h-4 w-full" />
        <Shimmer className="h-4 w-11/12" />
        <Shimmer className="h-4 w-10/12" />
        <Shimmer className="h-4 w-9/12" />
      </div>

      <div className="flex flex-col gap-4">
        <Shimmer className="h-6 w-48" />
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="flex flex-col gap-3">
              <Shimmer className="aspect-square w-full rounded-lg" />
              <Shimmer className="h-4 w-11/12" />
              <Shimmer className="h-4 w-2/3" />
              <Shimmer className="h-5 w-1/3" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
